import { useCallback, useEffect, useState } from "react";
import { gymClient } from "../apiClient/gymClient";
import type { BookingWithAttendee } from "../types/gym.types";

interface CoachScheduleState {
  bookings: BookingWithAttendee[];
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

/** The day's roster for the coach check-in screen. */
export function useCoachSchedule(date: string): CoachScheduleState {
  const [bookings, setBookings] = useState<BookingWithAttendee[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setBookings(await gymClient.getCoachSchedule(date));
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load the roster.");
    } finally {
      setIsLoading(false);
    }
  }, [date]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { bookings, isLoading, error, refresh };
}
